import React, { useState, useEffect } from 'react';
import { Container, Box, Typography, Paper, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import SpreadsheetUpload from '../components/SpreadsheetUpload';

const TemplateComparison = () => {
  const [templateType, setTemplateType] = useState<string>('Debtors'); // Default template is Debtors

  useEffect(() => {
    // Automatically update templateType on selection without using onChange
    console.log(`Template Type Selected: ${templateType}`);
  }, [templateType]);

  const handleUpload = (sheetA: File | null, sheetB: File | null) => {
    console.log(`Template Comparison - ${templateType} - Sheet A:`, sheetA);
    console.log(`Template Comparison - ${templateType} - Sheet B:`, sheetB);
  };

  return (
    <Container maxWidth="lg" sx={{ textAlign: 'center', paddingTop: '50px' }}>
      {/* Header Section */}
      <Box
        sx={{
          backgroundColor: '#183B4E',
          color: 'white',
          padding: '30px',
          borderRadius: '8px',
          marginBottom: '40px',
        }}
      >
        <Typography variant="h3" sx={{ fontWeight: 'bold', marginBottom: '20px' }}>
          Template Comparison
        </Typography>
        <Typography variant="h6" sx={{ fontStyle: 'italic', marginBottom: '40px' }}>
          Compare pre-configured templates like Debtors, Policies, etc.
        </Typography>
      </Box>

      {/* Template Type Dropdown */}
      <Box sx={{ marginBottom: '30px' }}>
        <FormControl sx={{ minWidth: 200 }} variant="outlined">
          <InputLabel>Template Type</InputLabel>
          <Select
            value={templateType}
            label="Template Type"
            onChange={(e) => setTemplateType(e.target.value)}
            sx={{
              width: '100%',
              backgroundColor: '#fff',
              borderRadius: '8px',
              padding: '10px',
              fontSize: '16px',
            }}
          >
            <MenuItem value="Debtors">Debtors</MenuItem>
            <MenuItem value="Policies">Policies</MenuItem>
            <MenuItem value="Renewals">Renewals</MenuItem>
          </Select>
        </FormControl>
      </Box>

      {/* File Upload Section */}
      <Paper
        elevation={6}
        sx={{
          padding: '30px',
          borderRadius: '8px',
          marginTop: '30px',
          backgroundColor: '#f5f5f5',
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: 'bold', marginBottom: '20px' }}>
          Upload Your {templateType} Templates
        </Typography>
        <SpreadsheetUpload onUpload={handleUpload} />
      </Paper>
    </Container>
  );
};

export default TemplateComparison;